import React, { useState } from 'react'
import Box from '@material-ui/core/Box'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Typography from '@material-ui/core/Typography'
import UpcomingSessions from './upcoming'
import PastSessions from './past'
import { useStyles } from './styles'

const SESSIONS_HEADING_ID = 'club-sessions-heading'

const SessionsSection = ({ studentId, onBookClick }) => {
  const classes = useStyles()
  const [selectedTab, setSelectedTab] = useState('upcoming')

  return (
    <Box className={classes.sessionsSection}>
      <Box className={classes.sessionsHeader}>
        <Typography
          id={SESSIONS_HEADING_ID}
          component="h3"
          className={`${classes.sectionTitle} ${classes.sessionsTitle}`}
        >
          Sessions
        </Typography>
        <Tabs
          className={classes.sessionTabs}
          value={selectedTab}
          onChange={(_, value) => setSelectedTab(value)}
          aria-labelledby={SESSIONS_HEADING_ID}
        >
          <Tab
            className={classes.sessionTab}
            label="Upcoming"
            value="upcoming"
          />
          <Tab className={classes.sessionTab} label="Past" value="past" />
        </Tabs>
      </Box>
      <Box className={classes.sessionTabPanel}>
        {selectedTab === 'upcoming' ? (
          <UpcomingSessions
            studentId={studentId}
            onBookClick={onBookClick}
            embedded
          />
        ) : (
          <PastSessions studentId={studentId} embedded />
        )}
      </Box>
    </Box>
  )
}

export default SessionsSection
